module.exports = {
	"id": "/tourn_match_day",
	"type": "object",
	"properties": {
		"countryId": {
			"type": "integer",
			"required": true
		},
		"tournamentId": {
			"type": "integer",
			"required": true
		},
		"seasonId": {
			"type": "integer",
			"required": true
		},
		"sportId": {
			"type": "integer",
			"required": true
		},
		"eventIds": {
			"required": true,
			"type": "array",
			"items": {
				"type": "integer"
			}
		}
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ../src/config/message_schemas/triggers/tourn_match_day.json
 ** module id = 1834
 ** module chunks = 0
 **/